export default "__VITE_ASSET__DmV5O4sr__"